import React from 'react'
import { useEffect, useState } from "react";

import API from '../utils/api.js'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import {  Bar, Doughnut } from 'react-chartjs-2';

  
  ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);


const data_inicio_bar = {
    labels: ['Sin resultados'],
    datasets: [
      {
        label: 'Ganancia Neta',
        data: [0],
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };
  

  
const data_inicio_donut = {
    labels: ["Sin resultados"],
    datasets: [
      {
        data: [0],
        backgroundColor: ["rgba(255, 99, 132, 0.2)"],
        borderColor: ["rgba(255, 99, 132, 1)"],
        borderWidth: 1,
      },
    ],
  };


const MediosPago = () => {
    var url = API.urlAPI
    const urlMedios = url + "prestamos/MediosPago"

    const optionsBar = {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          }
        }
      };

      const [dataDonut, setDataDonut] = useState(data_inicio_donut);

    const [dataBar, setDataBar] = useState(data_inicio_bar)

    const [dataDonut2, setDataDonut2] = useState(data_inicio_donut);

    const [dataBar2, setDataBar2] = useState(data_inicio_bar)

    
    const [dataBar3, setDataBar3] = useState(data_inicio_bar)

    
    const [dataBar4, setDataBar4] = useState(data_inicio_bar)


    const fetchMedios = async() => {
        let resp = await fetch(urlMedios)
        let dataBarra = await resp.json()
    
        let tipoventa = dataBarra.filter((dato) => dato.Tipo === "Ventas" && dato.medioPago === "EF") ;
        
      let modeloBar = {
        labels: tipoventa.map((data) => data.Mes),
        datasets: [
          {
            label: 'Importe ventas Efectivo',
            data: tipoventa.map((data) => data.Importe),
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          }
        ]
      };
      setDataBar(modeloBar)
      

      let tipoventa3 = dataBarra.filter((dato) => dato.Tipo === "Ventas" && dato.medioPago === "TR") ;
        
      let modeloBar3 = {
        labels: tipoventa3.map((data) => data.Mes),
        datasets: [
          {
            label: 'Importe ventas Transferencia',
            data: tipoventa3.map((data) => data.Importe),
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          }
        ]
      };
      setDataBar3(modeloBar3)
      
         

      let tipoventa4 = dataBarra.filter((dato) => dato.Tipo === "Creditos" && dato.medioPago === "TR") ;
        
      let modeloBar4 = {
        labels: tipoventa4.map((data) => data.Mes),
        datasets: [
          {
            label: 'Importe Creditos Transferencia',
            data: tipoventa4.map((data) => data.Importe),
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          }
        ]
      };
      setDataBar4(modeloBar4)
      
      


      let tipocredi = dataBarra.filter((dato) => dato.Tipo === "Creditos" && dato.medioPago === "EF");
      console.log(tipocredi )

      let modeloBar2 = {
        labels: tipocredi.map((data) => data.Mes),
        datasets: [
          {
            label: 'Importe Creditos Efectivo',
            data: tipocredi.map((data) => data.Importe),
            backgroundColor: 'rgba(53, 162, 235, 0.5)',
          }
        ]
      };
      setDataBar2(modeloBar2)
      let modeloDonut2 = {
        labels: tipocredi.map((data) => data.medioPago),
        datasets: [
          {
            data: tipocredi.map((data) => data.Importe),
            backgroundColor: ["#9e9e9e", "#757575"],
            borderColor: ["#424242", "#212121"],
            borderWidth: 1,
          },
        ],
      };
      setDataDonut2(modeloDonut2);
      
    
      }


      
  useEffect(() => {
    fetchMedios()
  }, [])
    
      
  return (
    <div>
        <br></br>
        <div className="row">
                <div className="col-xl-6 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Medios de Pago Ventas Efectivo</h6>

            </div>
            <div className="card-body " >
              <div style={{ height: 350 }}>
            
              
        <Bar type='bar' data={dataBar} />
              </div>

            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Medios de Pago Venta Transferencia</h6>

            </div>
            <div className="card-body " >
              <div style={{ height: 350 }}>
            
              
              <Bar type='bar' data={dataBar3} />
              </div>

            </div>
          </div>
        </div>

    </div>
    <br></br>
        <div className="row">
                <div className="col-xl-6 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Medios de Pago Créditos Efectivo</h6>

            </div>
            <div className="card-body " >
              <div style={{ height: 350 }}>
            
              
        <Bar type='bar' data={dataBar2} />
              </div>

            </div>
          </div>
        </div>
        <div className="col-xl-6 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between bg-primary">
              <h6 className="m-0 font-weight-bold text-white">Medios de Pago Créditos Transferencia</h6>

            </div>
            <div className="card-body " >
              <div style={{ height: 350 }}>
            
              
       
              <Bar type='bar' data={dataBar4} />
              </div>

            </div>
          </div>
        </div>

    </div>
    </div>
    
  )
}

export default MediosPago